<template>

  <div class="awards-info-heading" v-if="isActiveSection">
    <PublicEventPrices v-if="isActivePrices()" class="event-prices" />
    <div v-if="isMobileScreen" class="award-info">INFO</div>
    <p class="awards-info-nested-text" v-html="award.description" />
    <PreviousEdition v-if="isMobileScreen && award.previous_edition" />
    <EventPrices v-if="showPrices" class="event-prices" />
  </div>
  <div v-else style="text-align: center; color: #BD9D5F">The section is not available now and coming soon...</div>
</template>

<script>
import { mapGetters } from 'vuex';
import PreviousEdition from '../../../components/EventList/PreviousEdition.vue';
import EventPrices from '../../../components/advertisement/EventPrices.vue';
import PublicEventPrices from '../../../components/advertisement/PublicEventPrices.vue';

export default {
  components: {
    PreviousEdition,
    EventPrices,
    PublicEventPrices,
  },
  computed: {
    ...mapGetters({
      award: 'awards/award',
      isMobileScreen: 'isMobileScreen',
    }),
    isActiveSection() {
      return this.award && this.award.available_sections ? this.award.available_sections.includes('info') : false;
    },
    showPrices() {
      return this.isMobileScreen && this.isActivePrices() && this.$route.name !== 'PublicAwardInfo';
    },
  },
  methods: {
    isActivePrices() {
      return this.isMobileScreen && this.award && this.award.available_sections.includes('prices') && this.$route.name === 'PublicAwardInfo';
    },
  },
};
</script>

<style scoped>
.awards-info-nested-text {
  padding: 18px 12px;
  background-color: #fff;
  border-radius: 0 0 10px 10px;
  font-size: 11px;
}
.award-info {
  padding: 16px;
  background-color: #fff;
  color: #333;
  font-size: 13px;
  text-align: center;
  border-radius: 0 10px 0 0;
  margin-bottom: 2px;
}
.awards-info-nested-text >>> p img {
  max-width: 100%;
  object-fit: cover;
}
.awards-info-nested-text >>> iframe {
  width: 100%;
  height: 250px;
  object-fit: cover;
}
.awards-info-heading {
  margin-bottom: 50px;
}
</style>
